import { useLatestCallback } from '@marketplace-web/shared/ui-state-util'
import {
  SelectedDynamicFilterModel,
  getBrandById,
  transformBrandDto,
} from '@marketplace-web/catalog/catalog-data'

import {
  useCatalogContext,
  CatalogBrandReducerAction,
} from '@marketplace-web/catalog/catalog-page-data'

type FetchBrandParams = {
  selectedDynamicFilters: Array<SelectedDynamicFilterModel>
}

const useFetchCatalogBrand = () => {
  const { state, dispatch } = useCatalogContext()
  const { catalogBrand } = state

  const fetchBrand = useLatestCallback(async ({ selectedDynamicFilters }: FetchBrandParams) => {
    const selectedBrandFilters = selectedDynamicFilters.find(filter => filter.type === 'brand')

    if (selectedBrandFilters?.ids.length === 1) {
      const brandId = selectedBrandFilters.ids[0]!
      const currentBrand = catalogBrand.brand

      if (currentBrand?.id !== brandId) {
        const response = await getBrandById(brandId)

        if ('errors' in response) {
          dispatch({ type: CatalogBrandReducerAction.REMOVE_CATALOG_BRAND, payload: undefined })
        } else {
          const { brand } = response

          if (brand) {
            dispatch({
              type: CatalogBrandReducerAction.SET_CATALOG_BRAND,
              payload: { brand: transformBrandDto(brand) },
            })
          }
        }
      }
    } else {
      dispatch({ type: CatalogBrandReducerAction.REMOVE_CATALOG_BRAND, payload: undefined })
    }
  })

  return fetchBrand
}

export default useFetchCatalogBrand
